import { useForm, useFormContext } from 'react-hook-form';

import { ControlsFormFieldValues } from '../types';

export const useControlsForm = useForm<ControlsFormFieldValues>;

export const useControlsContext = useFormContext<ControlsFormFieldValues>;
